import { createSlice } from "@reduxjs/toolkit";
import {
  GetActiveUserAction,
  GetAllUserAction,
  GetChildKnot,
  GetGuardianChilds,
  GetGuardianDetailAction,
  GetUserDetailAction,
  GetUserGuardians,
  GetUserLocationAction,
  GetUserMatches,
  GetUserNotificationAction,
  GetUserReports,
  GetUserSuggested,
  StatusManageUserAction,
} from "store/middlewares/user";
// isDeleteMeFulFilled
export const userSlice = createSlice({
  name: "user",
  initialState: {
    userLoading: true,
    user: null,
    userDetailLoading: true,
    userDetail: null,
    productGallaryLoading: true,
    productGallary: null,
    notification: null,
    notificationLoading: false,
    activeUser: null,
    activeUserLoading: false,
    userLocation: null,
    userLocationLoading: false,
    userMatches: null,
    userMatchesLoading: false,
    userReports: null,
    userReportsLoading: false,
    guardians: null,
    guardiansLoading: false,
    guardianDetails: null,
    guardianDetailsLoading: false,
    childs: null,
    childsLoading: false,
    childKnots: null,
    childKnotsLoading: false,
    userSuggested: null,
    userSuggestedLoading: false,
  },
  reducers: {
    updateImageStatus: (state, action) => {
      state.userDetail.image_status = action.payload.status;
      state.userDetail.image_reject_reason = action.payload.reason;
      state.userDetail.profile_url =
        action.payload.status === "rejected"
          ? null
          : state.userDetail.profile_url;
    },
    updateExtraImageStatus: (state, action) => {
      const { id, status, reason } = action.payload;

      const image = state.userDetail?.user_images?.find((img) => img.id === id);

      if (image) {
        image.status = status;
        image.reason = reason;
      }
    },

    updateUserStatusManage: (state, action) => {
      const { reason } = action.payload;
      state.userDetail = {
        ...state.userDetail,
        ...action.payload,
        delete_reason: reason ? reason : null,
      };
    },
  },
  extraReducers(builder) {
    builder
      //get user
      .addCase(GetAllUserAction.pending, (state) => {
        // state.usersLoading = state.users?.users?.length > 0 ? false : true;

        state.user = state.user?.data?.length > 0 ? state.user : null;
      })
      .addCase(GetAllUserAction.fulfilled, (state, action) => {
        state.userLoading = false;
        state.user = action.payload.response;
      })
      .addCase(GetAllUserAction.rejected, (state) => {
        state.userLoading = false;
        state.user = null;
      })

      //get active user
      .addCase(GetActiveUserAction.pending, (state) => {
        state.activeUserLoading = true;
        state.activeUser = null;
      })
      .addCase(GetActiveUserAction.fulfilled, (state, action) => {
        state.activeUserLoading = false;
        state.activeUser = action.payload.response;
      })
      .addCase(GetActiveUserAction.rejected, (state) => {
        state.activeUserLoading = false;
        state.activeUser = null;
      })

      //Delete user
      .addCase(StatusManageUserAction.fulfilled, (state, action) => {
        state.userLoading = false;
        state.user = action.payload.response;
      })

      //get notification
      .addCase(GetUserNotificationAction.pending, (state) => {
        state.notificationLoading = true;
        state.notification = null;
      })
      .addCase(GetUserNotificationAction.fulfilled, (state, action) => {
        state.notificationLoading = false;
        state.notification = action.payload.response;
      })
      .addCase(GetUserNotificationAction.rejected, (state) => {
        state.notificationLoading = false;
        state.notification = null;
      })

      //get user location
      .addCase(GetUserLocationAction.pending, (state) => {
        /* state.userLocationLoading = true; */
        state.userLocation =
          state.userLocation?.data?.length > 0 ? state.userLocation : null;
      })
      .addCase(GetUserLocationAction.fulfilled, (state, action) => {
        state.userLocationLoading = false;
        state.userLocation = action.payload.response;
      })
      .addCase(GetUserLocationAction.rejected, (state) => {
        state.userLocationLoading = false;
        state.userLocation = null;
      })

      //get user detail
      .addCase(GetUserDetailAction.pending, (state) => {
        state.userDetailLoading = true;
        state.userDetail = null;
      })
      .addCase(GetUserDetailAction.fulfilled, (state, action) => {
        state.userDetailLoading = false;
        state.userDetail = action.payload.response;
      })
      .addCase(GetUserDetailAction.rejected, (state) => {
        state.userDetailLoading = false;
        state.userDetail = null;
      })

      //get user matches
      .addCase(GetUserMatches.pending, (state) => {
        state.userMatchesLoading =
          state.userMatches?.data?.length > 0 ? false : true;
        state.userMatches =
          state.userMatches?.data?.length > 0 ? state.userMatches : null;
      })
      .addCase(GetUserMatches.fulfilled, (state, action) => {
        state.userMatchesLoading = false;
        state.userMatches = action.payload.response;
      })
      .addCase(GetUserMatches.rejected, (state) => {
        state.userMatchesLoading = false;
        state.userMatches = null;
      })

      .addCase(GetUserReports.pending, (state) => {
        state.userReportsLoading =
          state.userReports?.result?.length > 0 ? false : true;
        state.userReports =
          state.userReports?.result?.length > 0 ? state.userReports : null;
      })
      .addCase(GetUserReports.fulfilled, (state, action) => {
        state.userReportsLoading = false;
        state.userReports = action.payload.response;
      })
      .addCase(GetUserReports.rejected, (state) => {
        state.userReportsLoading = false;
        state.userReports = null;
      })

      .addCase(GetUserGuardians.pending, (state) => {
        state.guardiansLoading =
          state.guardians?.result?.length > 0 ? false : true;
        state.guardians =
          state.guardians?.result?.length > 0 ? state.guardians : null;
      })
      .addCase(GetUserGuardians.fulfilled, (state, action) => {
        state.guardiansLoading = false;
        state.guardians = action.payload.response;
      })
      .addCase(GetUserGuardians.rejected, (state) => {
        state.guardiansLoading = false;
        state.guardians = null;
      })

      .addCase(GetGuardianDetailAction.pending, (state) => {
        state.guardianDetailsLoading = true;
        state.guardianDetails = null;
      })
      .addCase(GetGuardianDetailAction.fulfilled, (state, action) => {
        state.guardianDetailsLoading = false;
        state.guardianDetails = action.payload.response;
      })
      .addCase(GetGuardianDetailAction.rejected, (state) => {
        state.guardianDetailsLoading = false;
        state.guardianDetails = null;
      })

      .addCase(GetGuardianChilds.pending, (state) => {
        state.childsLoading = state.childs?.childs?.length > 0 ? false : true;
        state.childs =
          state.childs?.childs?.length > 0 ? state.childKnots : null;
      })
      .addCase(GetGuardianChilds.fulfilled, (state, action) => {
        state.childsLoading = false;
        state.childs = action.payload.response;
      })
      .addCase(GetGuardianChilds.rejected, (state) => {
        state.childsLoading = false;
        state.childs = null;
      })

      .addCase(GetChildKnot.pending, (state) => {
        state.childKnotsLoading =
          state.childKnots?.data?.length > 0 ? false : true;
        state.childKnots =
          state.childKnots?.data?.length > 0 ? state.childKnots : null;
      })
      .addCase(GetChildKnot.fulfilled, (state, action) => {
        state.childKnotsLoading = false;
        state.childKnots = action.payload.response;
      })
      .addCase(GetChildKnot.rejected, (state) => {
        state.childKnotsLoading = false;
        state.childKnots = null;
      })

      .addCase(GetUserSuggested.pending, (state) => {
        state.userSuggestedLoading =
          state.userSuggested?.data?.length > 0 ? false : true;
        state.userSuggested =
          state.userSuggested?.data?.length > 0 ? state.userSuggested : null;
      })
      .addCase(GetUserSuggested.fulfilled, (state, action) => {
        state.userSuggestedLoading = false;
        state.userSuggested = action.payload.response;
      })
      .addCase(GetUserSuggested.rejected, (state) => {
        state.userSuggestedLoading = false;
        state.userSuggested = null;
      });
  },
});
export const {
  updateImageStatus,
  updateUserStatusManage,
  updateExtraImageStatus,
} = userSlice.actions;
export default userSlice.reducer;
